import { useEffect, useState } from "react";
import en from "react-phone-number-input/locale/en";
import { GET_TENANT_DETAILS } from "../config/urls";
import { useAuth } from "./AuthProvider";

const DEFAULT_COUNTRY_ISO = "IN";

// One request per tenant, shared by every component that mounts the hook
const tenantCountryRequests = {};

// Tenant details store the country as a name ("United Arab Emirates"); the phone pickers need its ISO code
const getIsoFromCountryName = (countryName) => {
  const name = (countryName || "").trim().toLowerCase();
  return Object.keys(en).find((iso) => iso.length === 2 && en[iso].toLowerCase() === name);
};

const fetchTenantCountryIso = async (getValidToken, tenant) => {
  const token = await getValidToken();
  const response = await fetch(GET_TENANT_DETAILS, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "X-Tenant-ID": tenant,
    },
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  const data = await response.json();
  return getIsoFromCountryName(data?.results?.[0]?.country) || DEFAULT_COUNTRY_ISO;
};

// ISO code of the tenant's billing country, falling back to India until loaded or if unknown
const useTenantCountryIso = () => {
  const { getValidToken } = useAuth();
  const [countryIso, setCountryIso] = useState(DEFAULT_COUNTRY_ISO);

  useEffect(() => {
    const tenant = localStorage.getItem("tenant");
    if (!tenantCountryRequests[tenant]) {
      tenantCountryRequests[tenant] = fetchTenantCountryIso(getValidToken, tenant).catch((err) => {
        console.error("Error fetching tenant country:", err);
        delete tenantCountryRequests[tenant];
        return DEFAULT_COUNTRY_ISO;
      });
    }
    let active = true;
    tenantCountryRequests[tenant].then((iso) => active && setCountryIso(iso));
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return countryIso;
};

export default useTenantCountryIso;
